export class RouteConstant {
    static login: string = 'login';
    static auth: string = 'auth';
}
